import React, { useState } from 'react';
import { ContractStatus } from './ContractStatus';
import { ContractStats } from './ContractStats';
import { FeeManagement } from './FeeManagement';
import { PackageManager } from './PackageManager';
import { PriceControl } from './PriceControl';
import { WalletManagement } from './WalletManagement';
import { VirtualUsers } from './VirtualUsers';
import { Blacklist } from './Blacklist';
import { RankPoolDistribute } from './RankPoolDistribute';
import { RankLevelManager } from './RankLevelManager';
import { MilestoneRewarder } from './MilestoneRewarder';
import { TokenReserves } from './TokenReserves';

const TABS = [
  { id: 'overview',   label: 'Overview',      icon: '📊' },
  { id: 'fees',       label: 'Fees',          icon: '💵' },
  { id: 'packages',   label: 'Packages',      icon: '📦' },
  { id: 'ranks',      label: 'Ranks/Levels',  icon: '🏆' },
  { id: 'price',      label: 'Price',         icon: '💱' },
  { id: 'pools',      label: 'Rank Pools',    icon: '🏦' },
  { id: 'virtual',    label: 'Virtual Users', icon: '👻' },
  { id: 'milestones', label: 'Milestones',    icon: '⭐' },
  { id: 'blacklist',  label: 'Blacklist',     icon: '🚫' },
  { id: 'wallets',    label: 'Wallets/Roles', icon: '👛' },
  { id: 'reserves',   label: 'Reserves',      icon: '🏛️' }
];

export const AdminPanel = () => {
  const [tab, setTab] = useState('overview');

  return (
    <div>
      <div className="admin-badge-header">🔐 ADMIN PANEL</div>
      <div className="page-header">
        <div>
          <div className="page-title">Admin Control Center</div>
          <div className="page-subtitle">Full contract configuration and management interface</div>
        </div>
      </div>

      <ContractStatus />

      <div className="admin-tabs">
        {TABS.map((t) => (
          <button key={t.id} className={`admin-tab ${tab === t.id ? 'active' : ''}`} onClick={() => setTab(t.id)}>
            <span style={{ marginRight: 6 }}>{t.icon}</span>{t.label}
          </button>
        ))}
      </div>

      <div className="admin-section">
        {tab === 'overview'   && <ContractStats />}
        {tab === 'fees'       && <FeeManagement />}
        {tab === 'packages'   && <PackageManager />}
        {tab === 'ranks'      && <RankLevelManager />}
        {tab === 'price'      && <PriceControl />}
        {tab === 'pools'      && <RankPoolDistribute />}
        {tab === 'virtual'    && <VirtualUsers />}
        {tab === 'milestones' && <MilestoneRewarder />}
        {tab === 'blacklist'  && <Blacklist />}
        {tab === 'wallets'    && <WalletManagement />}
        {tab === 'reserves'   && <TokenReserves />}
      </div>
    </div>
  );
};
